<template>
  <v-container class="px-1 py-0">
     <v-data-table
      :headers="headers"
      :items="lotesList"
      hide-default-footer
      :options.sync="options"
      class="lotesVinculadosTable"
      dense
    >
      <template v-slot:item.arq_nome="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }" >
              <span v-bind="attrs" v-on="on" class="pa-0">
                {{ item.arq_nome }}
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{ item.arq_nome }}</span>
          </v-tooltip>
      </template>
      <template v-slot:item.data_upload="{ item }" class="px-1 py-0">
        <span>{{ item.data_upload != null && item.data_upload != "0001-01-01T00:00:00"? (item.data_upload | formatDate) : null}}</span>
      </template>
      <template v-slot:item.valor_informado="{ item }" class="px-1 py-0">
        <b>{{ item.valor_informado | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_conciliado="{ item }">
        <b>{{ item.valor_conciliado | formatPrice }}</b> ({{item.perc_valor_conciliado | formatPrice }}%)
      </template>
      <template v-slot:item.valor_liberado="{ item }">
        <b style="color:green">{{ item.valor_liberado | formatPrice }}</b> ({{item.perc_valor_liberado | formatPrice }}%)
      </template>
      <template v-slot:item.valor_glosado="{ item }">
        <b style="color:red">{{ item.valor_glosado | formatPrice }}</b> ({{item.perc_valor_glosado | formatPrice }}%)
      </template>
    </v-data-table>
    <p class="text-right"><small>Valores em Reais (R$)</small></p>
    <div class="text-center mt-n5 py-0 col-md-12">
      <v-pagination
        class="no-box-shadow"
        v-model="pageLotes"
        :length="lotesPagination.total_pages"
        @input="getLotesPagamento(pagamentoId, {offset:pageLotes})"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
export default {
  data() {
    return {
      lotesList: [],
      pageLotes: 1,
      options: null,
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch:{
    lotes:{
      deep: true,
      handler(val) {
        this.lotesList = val? val.dados: []
      }
    },
    options(item){
      this.pageLotes = 1
      let sort = item.sortBy[0] ? item.sortBy[0] : null;
      let order =
        item.sortDesc.length > 0 ? (item.sortDesc[0] ? "Desc": "Asc") : null;
      let options = { offset: 1, sort, order}
      this.getLotesPagamento(this.pagamentoId, options)
    }
  },
  props: {
    getLotesPagamento: Function,
    lotes: Object,
    lotesPagination: Object,
    headers: Array,
    pagamentoId: String
  }
};
</script>

<style>
.theme--light.v-data-table.lotesListTable   .v-icon.v-icon {
    font-size: 16px !important;
}
i.v-icon.notranslate.text-icon.material-icons.theme--light.red--text {
  font-size: 12px;
  font-weight: 600;
  font-family: "Catamaran";
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
.theme--light.v-data-table.lotesVinculadosTable > .v-data-table__wrapper > table > thead > tr > th,
.theme--light.v-data-table.lotesVinculadosTable > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 5px
}
.theme--light.v-data-table.lotesVinculadosTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(1),
.theme--light.v-data-table.lotesVinculadosTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(1) {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow-x: hidden;
    white-space: nowrap;
    word-wrap: nowrap;
}
.theme--light.v-data-table.lotesVinculadosTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(1) > span {
    white-space: nowrap;
}
</style>